import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import parse from "html-react-parser";
import { AI_ASSISTANT_BLUE, MESSAGE_STATUS } from "./constants";

function looksLikeHtml(text) {
  return /<\/?[a-z][\s\S]*>/i.test(String(text || ""));
}

export default function AIChatMessage({ message, onRetry }) {
  const isUser = message.role === "user";
  const failed = message.status === MESSAGE_STATUS.FAILED;
  const content = message.content || "";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: isUser ? "flex-end" : "flex-start",
        mb: 1.5,
        px: 0.5,
      }}
    >
      <Box
        sx={{
          maxWidth: "92%",
          px: 1.6,
          py: 1.2,
          borderRadius: isUser ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
          bgcolor: isUser ? AI_ASSISTANT_BLUE : "#ffffff",
          color: isUser ? "#fff" : "#0f172a",
          border: isUser ? "none" : "1px solid rgba(148,163,184,0.28)",
          boxShadow: isUser
            ? "0 8px 18px rgba(0, 97, 254, 0.18)"
            : "0 4px 14px rgba(15, 23, 42, 0.04)",
          opacity: failed ? 0.85 : 1,
          outline: failed ? "1px solid #ef4444" : "none",
        }}
      >
        {isUser || !looksLikeHtml(content) ? (
          <Typography
            component="div"
            sx={{
              fontSize: 14,
              lineHeight: 1.55,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {content}
          </Typography>
        ) : (
          <Box
            sx={{
              fontSize: 14,
              lineHeight: 1.55,
              "& p": { margin: 0, mb: 1 },
              "& p:last-of-type": { mb: 0 },
              "& ul, & ol": { margin: "6px 0 0", pl: 2.5 },
              "& li": { marginBottom: 0.5 },
              "& strong, & b": { fontWeight: 700 },
              "& a": { color: AI_ASSISTANT_BLUE },
            }}
          >
            {parse(content)}
          </Box>
        )}
      </Box>
      {failed && typeof onRetry === "function" ? (
        <Button
          size="small"
          startIcon={<RefreshRoundedIcon fontSize="small" />}
          onClick={() => onRetry(message)}
          sx={{ mt: 0.6, textTransform: "none", fontSize: 12, color: "#b91c1c" }}
        >
          Retry
        </Button>
      ) : null}
    </Box>
  );
}

AIChatMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string,
    role: PropTypes.string,
    content: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onRetry: PropTypes.func,
};
